import React from "react";

export default function Header() {
  return (
    <div className="header-container">
      <h1>
        <a href="/" title="The Kawaii Face">
          The Kawaii Face (｡◕‿◕｡)
        </a>
      </h1>
    </div>
  );
}
//Change anchor tag
